var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 90 90",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m84.648 44.906c0 21.917-17.761 39.677-39.677 39.677-10.521 0-20.615-4.177-28.052-11.62-7.443-7.437-11.626-17.53-11.626-28.057 0-21.911 17.766-39.678 39.678-39.678 21.916.001 39.677 17.768 39.677 39.678z",
    fill: "#f9f9f9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44.976 25.146c2.624 0 5.14 1.042 7 2.901 1.853 1.854 2.896 4.369 2.896 7-.005 3.015-1.387 5.869-3.756 7.744-1.25 1.376-.621 2.448.489 2.876 5.533 1.224 9.59 5.561 9.59 11.552 0 2.833.238 3.452-2.833 3.452h-27.438c-2.391 0-2.172-1.593-2.172-3.452 0-5.991 4.063-10.333 9.593-11.552 1.099-.428 1.729-1.485.517-2.844-2.386-1.875-3.781-4.746-3.781-7.776 0-2.631 1.041-5.146 2.896-7 1.858-1.859 4.374-2.901 6.999-2.901z",
    fill: "#1a1a1a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m44.971 8.188c-20.246 0-36.724 16.475-36.724 36.719 0 20.245 16.479 36.724 36.724 36.724 6.5 0 12.609-1.708 17.91-4.687l-4.453-4.453c-4.062 1.984-8.619 3.12-13.457 3.12-16.995 0-30.705-13.709-30.705-30.704 0-7.057 2.371-13.547 6.355-18.73l11.329 11.327c-.517-2.561-.052-5.463.879-7.629l-8.082-8.083c5.396-4.724 12.462-7.588 20.224-7.588 16.989 0 30.708 13.713 30.708 30.703 0 7.761-2.864 14.833-7.593 20.229l-4.125-4.131c-1.036 2-3.516 2.882-5.631 2.882l9.631 9.629c8.364-6.739 13.735-17.057 13.735-28.609-.001-20.245-16.482-36.719-36.725-36.719z",
    fill: "#ff2a2a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanUser);
export default __webpack_public_path__ + "static/media/ban-user.dc9a42dfb504bf53474d0c204de08b54.svg";
export { ForwardRef as ReactComponent };